import React, { useState, useEffect } from 'react';
import { fetchUserDetails } from '../../../../api/userApi'; 
import authService from '../../../../services/authService';
import { FaUserShield } from 'react-icons/fa';
import './AdminProfile.css'; 
import { APP_VERSION } from '../../../../AppVersion/version';

const AdminProfile = () => {
  const [adminData, setAdminData] = useState({
    userName: 'N/A',
    email: 'N/A',
    mobileNo: 'N/A',
    userId: 'N/A',
    isActive: true,
    userRole: 0
  });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.title = 'Admin Profile - Finhaat Gurukul';

    const fetchAdminData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const adminId = authService.getUserId();
        if (!adminId) {
          throw new Error('No admin ID found');
        }

        const response = await fetchUserDetails(adminId); 
        const { data } = response;
        setAdminData({
          userName: data.userName || 'N/A',
          email: data.email || 'N/A',
          mobileNo: data.mobileNo || 'N/A',
          userId: data.userId || 'N/A',
          isActive: data.isActive === 1,
          userRole: data.userRole || 1
        });
      } catch (error) {
        setError('Failed to fetch admin details. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchAdminData();
  }, []);

  if (isLoading) {
    return <div className="spinner-container-admin-profile">
    <div className="spinner-admin-profile"></div>
  </div>
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className='admin-profile-container'>
      <div className="version-tag">v{APP_VERSION}</div>
      <div className="admin-profile">
        <div className="profile-header">
          <FaUserShield className="profile-icon" />
          <h1 className="admin-name">{adminData.userName}</h1>
          <p className="admin-contact">
            <span className='admin-contact-emailId'>Email: {adminData.email}</span>
            <span className='admin-contact-mobileNo'>Phone: {adminData.mobileNo}</span>
          </p>
        </div>
        <div className="profile-details">
          <p><span className='admin-profile-userId'>Admin User ID:</span> {adminData.userId}</p>
          <hr className="hr-profile" />
          <p><span className='admin-profile-status'>Account Status:</span> {adminData.isActive ? 'Active' : 'Inactive'}</p>
          <hr className="hr-profile" />
          <p><span className='admin-profile-role'>Assigned Role:</span> {adminData.userRole === 1 ? 'Admin' : 'Super Admin'}</p>
        </div>
      </div>
    </div>
  );
};

export default AdminProfile;
